import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFieldDropdown, BaasicFormControls, BasicTextArea, BaasicButton, DatePickerField, BasicCheckbox, BaasicConfirmModalNew } from 'core/components';
import { Content } from 'core/layouts';
import { observer } from 'mobx-react';
import { NikoPatientInsurancePreview } from "application/niko-patient/components";
import { Tooltip as ReactTooltip } from "react-tooltip";
function NikoFacilityOrderReasonForChangeModalTemplate({ nikoFacilityOrderReasonForChangeModalStore, t }) {
    const {
        tabItems,
        form,
        selectedTabItemAbrv,
        setTabItem,
        modalParams,
        eligibilityStatusStore,
        isEligibleInsuranceStatus,
        showTemplates,
        changeTemplatesVisibility,
        nikoPatientDetail,
        patientTemplates,
        getNikoPatient,
        resetPARFlags,
        loaderStore,
        sendOrder,
        eligibilityWarningModal,
        eligibilityErrorModal,
        parAcknowledgeModal,
        isInsurancePlansTabDisabled
    } = nikoFacilityOrderReasonForChangeModalStore;

    const tabButtons = tabItems ? tabItems.map(item => {
        // ISG-2625: block the "Insurance Plans" tab once a Niko Sales Order exists for this patient/DOS.
        const isDisabledTab = item.abrv === 'insurance-plans' && isInsurancePlansTabDisabled;
        const tabButton = (
            <BaasicButton key={item.abrv}
                disabled={form.submitting || form.validating}
                className={"tabs__item" + (item.abrv == selectedTabItemAbrv ? ' active' : '') + (isDisabledTab ? ' tabs__item--disabled' : '')}
                label={item.name}
                showTooltip={!isDisabledTab}
                onClick={() => (isDisabledTab || item.abrv == selectedTabItemAbrv) ? {} : setTabItem(item.abrv)}
            />
        );

        if (!isDisabledTab) return tabButton;

        return (
            <span key={item.abrv} data-tooltip-id="reasonForChangeInsuranceTabTooltip">
                {tabButton}
            </span>
        );
    }) : null;

    return (
        <div style={{ minHeight: 297 }}>
            <div className="modal__header">
                <h3 className='modal__header__title'>Insurances</h3>
            </div>
            <div className="modal__body">
                <Content loading={loaderStore.loading}>
                    <div className="u-mar--bottom--sml">
                        <h3 className='modal__header__title u-mar--bottom--sml'>
                            {nikoPatientDetail.nikoPatient.lastName && `${nikoPatientDetail.nikoPatient.lastName}`}
                            {nikoPatientDetail.nikoPatient.lastName && nikoPatientDetail.nikoPatient.firstName && ', '}
                            {nikoPatientDetail.nikoPatient.firstName && `${nikoPatientDetail.nikoPatient.firstName}`}
                        </h3>
                    </div>
                    <ReactTooltip
                        positionStrategy="fixed"
                        id="reasonForChangeInsuranceTabTooltip"
                        place="top"
                        render={() => (
                            <span>
                                Insurance Edits cannot be made in the portal after sales order creation.
                                <br />
                                Please update Insurances in Niko.
                            </span>
                        )}
                    />
                    <div className="tabs u-mar--bottom--med">
                        {tabButtons}
                    </div>
                    {selectedTabItemAbrv === 'insurance-eligibility' ?
                        <div className="row">
                            <div className="col col-sml-6 form__group u-mar--bottom--sml--alt">
                                <BaasicFieldDropdown field={form.$('eligibilityStatusId')} store={eligibilityStatusStore} allowEmpty={true} disabled={form.submitting || form.validating} />
                            </div>
                            <div className="col col-sml-6 form__group u-mar--bottom--sml--alt">
                                <DatePickerField field={form.$('effectiveDate')} disabled={form.submitting || form.validating} />
                            </div>
                            {isEligibleInsuranceStatus && patientTemplates.length > 0 &&
                                <div className="col col-sml-12 form__group u-mar--bottom--sml--alt">
                                    <div className="card--insurance-template">
                                        <div className="u-flex--space-between u-flex--grow--1" style={{ cursor: "pointer" }} onClick={() => { if (form.submitting || form.validating) return; changeTemplatesVisibility() }}>
                                            <label>{`PAR ${patientTemplates.filter(pt => pt.isPriorAuthNeeded).length > 0 ? `${patientTemplates.filter(pt => pt.isPriorAuthNeeded).length}/${patientTemplates.length}` : ''}`}</label>
                                            <i className={"u-icon u-icon--xsml " + (showTemplates ? "u-icon--arrow-up" : "u-icon--arrow-down") + " u-mar--left--sml"} />
                                        </div>

                                        {showTemplates && patientTemplates.map(item => {
                                            return (<PatientTemplateTable key={item.id} nikoFacilityOrderReasonForChangeModalStore={nikoFacilityOrderReasonForChangeModalStore} patientTemplate={item} />);
                                        })}
                                    </div>
                                </div>
                            }
                            <div className="col col-sml-12 form__group u-mar--bottom--sml--alt">
                                <BasicTextArea field={form.$('note')} rows={1} disabled={form.submitting || form.validating} />
                            </div>
                        </div>
                        :
                        <div className="row">
                            <NikoPatientInsurancePreview nikoPatientDetail={nikoPatientDetail} getNikoPatient={getNikoPatient} resetPARFlags={resetPARFlags} sendOrder={sendOrder}/>
                        </div>
                    }
                </Content>
            </div>
            {selectedTabItemAbrv === 'insurance-eligibility' &&
                <div className='modal__footer'>
                    <BaasicButton
                        disabled={form.submitting || form.validating}
                        className='btn btn--med btn--light'
                        label={t('EDIT_FORM_LAYOUT.CANCEL')}
                        onClick={() => modalParams.close()}
                    />
                    <BaasicFormControls
                        className='btn btn--med btn--primary'
                        form={form}
                        onSubmit={form.onSubmit}
                        disabled={form.submitting || form.validating}
                        label="Submit"
                    />
                </div>
            }
            {/* ISG-2621: eligibility-status Save pop-ups (E1 warning / E2 error / E3 PAR acknowledge). */}
            <BaasicConfirmModalNew modalParams={eligibilityWarningModal} />
            <BaasicConfirmModalNew modalParams={eligibilityErrorModal} />
            <BaasicConfirmModalNew modalParams={parAcknowledgeModal} className="modal--confirmation--narrow" />
        </div>
    )
}

NikoFacilityOrderReasonForChangeModalTemplate.propTypes = {
    nikoFacilityOrderReasonForChangeModalStore: PropTypes.object,
    t: PropTypes.func
};

const PatientTemplateTable = observer(({ nikoFacilityOrderReasonForChangeModalStore, patientTemplate }) => {
    const {
        setPriorAuthNeededd,
        changeItemsVisibility,
        form
    } = nikoFacilityOrderReasonForChangeModalStore;

    return (
        <div className="table--secondary__wrapper u-mar--top--sml is-add-new-disabled">
            <table width="100%" className="table--secondary">
                <colgroup>
                    <col width="250*" />
                    <col width="250*" />
                    <col width="250*" />
                </colgroup>
                <thead>
                    <tr>
                        <th colSpan={"3"}>
                            <div className='u-flex--default u-flex--align-items--center'>
                                <div>
                                    <BasicCheckbox id={patientTemplate.id} checked={patientTemplate.isPriorAuthNeeded} onChange={() => setPriorAuthNeededd(patientTemplate)} disabled={form.submitting || form.validating} />
                                </div>
                                <div className="u-flex--space-between u-flex--grow--1" style={{ cursor: "pointer" }} onClick={
                                    form.submitting || form.validating
                                        ? undefined
                                        : () => changeItemsVisibility(patientTemplate)
                                }>
                                    <label>{patientTemplate.subCategory.name.toUpperCase()}</label>
                                    <i className={"u-icon u-icon--xsml " + (patientTemplate.itemsVisible ? "u-icon--arrow-up" : "u-icon--arrow-down") + " u-mar--left--sml"} />
                                </div>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {patientTemplate.itemsVisible &&
                        <tr>
                            <td><span className="type--sml type--wgt--bold type--color--primary">ITEM NAME</span></td>
                            <td><span className="type--sml type--wgt--bold type--color--primary">ITEM ID</span></td>
                            <td><span className="type--sml type--wgt--bold type--color--primary">PROCEDURE CODE</span></td>
                        </tr>}
                    {patientTemplate.itemsVisible && patientTemplate.patientTemplateItems.map((item) => {
                        return (
                            <tr key={item.id} >
                                <td>
                                    {item.product && item.product.description}
                                </td>
                                <td>
                                    {item.product && item.product.itemId}
                                </td>
                                <td>
                                    {item.product && item.product.procedureCode_.abrv}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
});

PatientTemplateTable.propTypes = {
    nikoFacilityOrderReasonForChangeModalStore: PropTypes.object.isRequired,
    patientTemplate: PropTypes.object.isRequired
};

export default defaultTemplate(NikoFacilityOrderReasonForChangeModalTemplate);
